export default {
  computed: {
    isSafariDesktop: function () {
      return 'safari' in window && 'pushNotification' in window.safari
    },
  },
}
